import React, {useContext, useRef, useState} from 'react';
import {LayoutContext} from "../../../../../../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {usePagination} from "../../../../../../layout/hooks/usePagination";
import {useFetch} from "../../../../../../layout/hooks/useFetch";
import {webInfo} from "../../../../../../utils/webInfo";
import callToast, {handleChangeData, postData, validateFormFields} from "../../../../../../utils/helper";
import {Button} from "primereact/button";
import PageHeading from "../../../../../../Components/PageHeading";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import Label from "../../../../../../Components/Label";
import {InputText} from "primereact/inputtext";

interface InitialState {
    name: string,
}

const RequisitionTypes = () => {
    const initialState: InitialState = {
        name: ''
    };
    const {accessToken} = useContext(LayoutContext)
    const [refresh, setRefresh] = useState<boolean>(false);
    const [formData, setFormData] = useState<InitialState>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const toast = useRef<Toast | null>(null)

    const [modal, setModal] = useState<boolean>(false);
    const [updatedId, setUpdatedId] = useState<number | null>(null);

    // pagination
    const {page, limitData, handlePageChange} = usePagination();

    // endpoint
    const mainTitle = "Requisition Types"
    const tableDataEndpointUrl = `/requisition-types?page=${page} `
    const submitFormEndpointUrl = updatedId ? `/requisition-types/${updatedId}` : "/requisition-types";

    // fetch data
    const {
        data: tableDataList,
        totalData, loading
    } = useFetch(tableDataEndpointUrl, [refresh])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const validationRules = [
            { field: 'name', label: 'Name' },
        ];

        if (!validateFormFields(formData, validationRules, toast)) return;

        const payload = {name: formData.name.replace(/\s+/g, ' ').trim()};

        try {
            setIsSubmitting(true);
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData("PUT", accessToken, payload));
            if (response.ok) {
                callToast(toast, true, `${mainTitle} ${updatedId ? 'updated' : 'created'} successfully`);
                setFormData(initialState)
                setModal(false)
                setUpdatedId(null)
                setRefresh(!refresh);
                return;
            }else{
                const resData = await response.json();
                callToast(toast, false, resData.error);
            }



        } catch (err) {
            console.error('Failed to update', err);
        }finally {
            setIsSubmitting(false);
        }

    }

    // row edit template
    const actionTemplate = (rowData: any) => {
        return (
            <div className={'flex align-items-center justify-content-end'}>
                <Button icon={'pi pi-pencil'} className={'border-rounded w-2rem h-2rem'} onClick={() => {
                    setModal(true)
                    setUpdatedId(rowData?.id)
                    setFormData({name: rowData.name});

                }} outlined/>
            </div>
        )
    }
    return (
        <div className={"card"}>
            <Toast ref={toast}/>
            <PageHeading title={mainTitle}
                         isCreate={true}
                         createFunction={() => setModal(true)}
                         back={true}
            />

            <DataTable
                value={tableDataList}
                dataKey="id"
                tableStyle={{minWidth: '50rem'}}
                paginator={tableDataList?.length > 0}
                lazy
                first={(page - 1) * limitData}
                rows={limitData}
                totalRecords={totalData}
                loading={loading}
                onPage={handlePageChange}
            >

                <Column
                    field="name"
                    header="Name"
                    style={{width: '50%'}}
                    headerClassName={"white-space-nowrap"}/>
                <Column header={"Action"} rowEditor={true}
                        bodyStyle={{textAlign: 'center'}}
                        body={actionTemplate}
                        headerClassName={"flex justify-content-end"}
                />
            </DataTable>

            <Dialog visible={modal}
                    style={{width: "50rem"}}
                    headerClassName="text-800 font-semibold text-xl"
                    header={updatedId ? `Edit ${mainTitle}` : `New ${mainTitle}`}
                    breakpoints={{"960px": "75vw", "640px": "90vw"}}
                    onHide={() => {
                        setUpdatedId(null)
                        setModal(false)
                        setFormData(initialState)
                    }}
            >
                <div>
                    <form className={''}
                          onSubmit={handleSubmit}
                    >
                        <div className="grid ">

                            <div className="col-12 ">
                                <Label label={"Name"} required={!updatedId}/>
                                <InputText
                                    id="name"
                                    value={formData.name}
                                    size={100}
                                    name={"name"}
                                    onChange={(e) => handleChangeData('name', e.target.value, formData, setFormData)}
                                    placeholder={"Enter name"}
                                    className={`w-full`}

                                />
                            </div>

                        </div>
                        <div className="flex gap-2 mt-2">
                            <Button
                                type="submit"
                                label={updatedId ? 'Update' : "Create"}
                                className="p-button-primary"
                                size={'small'}
                                loading={isSubmitting}
                            />
                        </div>
                    </form>
                </div>
            </Dialog>

        </div>
    );
};

export default RequisitionTypes;